

















import {
    useVueRouter,
    useVuexStore,
} from '@superbet-group/web.lib.vue-utilities';
import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import authStore from '@store/modules/data/authentication/authenticationIndex';
import { useFormattedBalance } from '@app/modules/userProfile/composables/balance';
import AccountUserInfoAvatar from '@src/app/shared/components/Account/AccountUserInfoAvatar.vue';
import { RouteName } from '@src/app/router/constants/RouteName';
import inboxIndex from '@store/modules/ui/inbox/inboxIndex';
import { getShellConfig } from '@src/config/shell/config';
import { shellLocalConfig } from '@src/config/shell/localConfig';
import { Product } from '@src/app/router/products/Product';

export default defineComponent({
    name: 'MobileHeaderAvatar',
    props: {
        hideAvatar: {
            type: Boolean,
            default: false,
        },
    },
    setup() {
        const { router } = useVueRouter();
        const authModule = useVuexStore<typeof authStore>('data/authentication');
        const user = authModule.getter('user');
        const isLoggedIn = computed(() => !!user.value);
        const { formattedBalance } = useFormattedBalance();

        function onAvatarClick() {
            if (
                getShellConfig().localConfig.header.accountMenuAuthenticated?.isRedirect
                && getShellConfig().localConfig.header.accountMenuAuthenticated?.redirectRouteName
                && isLoggedIn.value
            ) {
                router.value.push({
                    name: getShellConfig().localConfig.header.accountMenuAuthenticated?.redirectRouteName,
                });
            }

            if (Product.Account.MyAccount) {
                router.value.push({
                    name: RouteName.Account.MyAccount,
                });
            }
        }

        const inboxStore = useVuexStore<typeof inboxIndex>('ui/inbox');
        const hasNotification = computed(() => {
            return inboxStore.state('numberOfNewMessages').value > 0;
        });

        return {
            user,
            formattedBalance,
            hasNotification,
            isLoggedIn,
            isBalanceShown: shellLocalConfig.header?.isBalanceShown,
            onAvatarClick,
        };
    },
    components: {
        AccountUserInfoAvatar,
    },
});
